import { render, staticRenderFns } from "./Error502.vue?vue&type=template&id=0c8e10a7&scoped=true"
import script from "./Error502.vue?vue&type=script&lang=js"
export * from "./Error502.vue?vue&type=script&lang=js"
import style0 from "./Error502.vue?vue&type=style&index=0&id=0c8e10a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e10a7",
  null
  
)

export default component.exports